import { createContext, useContext } from 'react'

export type Status = 'default' | 'error'

export type FormFieldContextType = {
  status: Status
}

const FormFieldContext = createContext<FormFieldContextType | null>(null)

export const useFormFieldContext = () => {
  const context = useContext(FormFieldContext)
  return context || { status: 'default' }
}

export const FormFieldProvider = FormFieldContext.Provider
